import { render, staticRenderFns } from "./UiPages.vue?vue&type=template&id=26d7a49c"
import script from "./UiPages.vue?vue&type=script&lang=js"
export * from "./UiPages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports